import styled from 'styled-components'

export const ContainerIcons = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 auto;
    margin-top: 4rem;
    justify-content: space-around;

    .innerIconContainer {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    img {
        width: 300px;
        max-width: 95%;
        margin-bottom: 1rem;
    }

    @media(max-width: 425px){
        .second-img, img {
            margin-left: 0.5rem;
            margin-right: 0;
        }
        p {
            margin-left: 1rem;
        }
    }
    
    
`